import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";
import shop_now_pay_later from "../images/shop_now_pay_later.png"
import shop from "../images/shop.png"
import tabby from "../images/tabby.webp"
import { getProductDetail, getrelatedItems } from "../redux/productslice";
import { useDispatch, useSelector } from "react-redux";
import { ComponentHeader } from "../components/Common";
import ImageCarousel from "../components/product-detail/ImageCarousel";
import { CarouselProducts } from "../components/homepage";
import { ProductCategoryFilters, ProductCardPlaceHolder, SubcategoryPlaceHolder } from "../components/placeholders/ProductCategory";
import { setprodcatloading } from "../redux/productslice";
import Cookies from "universal-cookie";
import { decode } from 'html-entities';
import ReactImageMagnify from 'react-image-magnify';
import { MediaQueries } from "../components/utils";
import ClipLoader from "react-spinners/ClipLoader";
import Snplmodal from "../components/product-detail/Snplmodal";
import Bankoffermodal from "../components/product-detail/Bankoffermodal"
import { useCart } from "../hooks";
import { setsnplmodal, setbankoffermodal } from "../redux/formslice"
import snpl from "../images/snpl.png"
import BreadComps from "../components/Common/Breadcomps";
import { pushToDataLayer } from "../components/utils/dataUserpush"
const ProductDetail = () => {
    const cookies = new Cookies();
    const { isMobile, isLaptop } = MediaQueries();
    const { add2cart, isLoading } = useCart();

    const authstatus = useSelector((state) => state.formslice.authstatus);
    const logindata = useSelector((state) => state.formslice.logindata);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const [bankofferdata, setbankofferdata] = useState()
    const { slug } = useParams();
    const dispatch = useDispatch()

    const loading = useSelector(state => state.productslice.loading);
    const loading1 = useSelector(state => state.productslice.loading1);
    const productDetail = useSelector(state => state.productslice.productDetail);
    const productDetail_products = useSelector(state => state.productslice.productDetail_products);
    const [current_image, setcurrent_image] = useState(0);

    useEffect(() => {
        dispatch(setsnplmodal(false))
        dispatch(setbankoffermodal(false))
    }, [])
    function decodeHtml(html) {
        return decode(html)
    }
    const bankofferclick = (bank_offer) => {
        dispatch(setbankoffermodal(true))
        setbankofferdata(bank_offer)
    }
    const saveCookies = () => {
        if (cookies.get("sku") == undefined) {
            cookies.set("sku", [slug])
        } else {
            cookies.set("sku", [...cookies.get("sku").filter(item => item != slug), slug])
        }
    }

    useEffect(() => {
        dispatch(setprodcatloading(true))
        saveCookies()
        setcurrent_image(0)
        dispatch(getProductDetail(slug))
    }, [slug])

    useEffect(() => {
        if (!loading) {
            var input_data = {
                brand_id: productDetail[0].brand_id,
                subcategory_id: productDetail[0].subcategory_id,
                sku: slug,
                skulist: cookies.get("sku")
            }
            dispatch(getrelatedItems(input_data))
        }
    }, [loading])


    const [view_more, setview_more] = useState(5);

    const handleViewMore = () => {
        if (view_more == productDetail[0].bank_offers.length) {
            setview_more(5)
        } else {
            setview_more(productDetail[0].bank_offers.length)
        }
    }
    useEffect(() => {
        pushToDataLayer("view_pdp", currentcountry.name, {
            product_name: productDetail[0]?.name,
            source: "pdp",
        }, true);
    }, [])

    const handleClick = async () => {
        var input_data = {
            "product_id": productDetail[0].id,
            "user_id": authstatus ? logindata.user_id : 0,
            "quantity": "1"
        }

        if (cookies.get("cart_ip_address") == undefined) {
            input_data.ip_address = 0
        } else {
            input_data.ip_address = cookies.get("cart_ip_address")
        }
        add2cart(input_data);
        //    var resp = await dispatch(addToCart(input_data));
        pushToDataLayer("clicked_add_to_cart", currentcountry.name, {
            product_name: productDetail[0]?.name,
            // source: "pdp",
        }, true);
    }

    return (
        <>
            <Container fluid className="pt-2 pb-3 homepagecontainer">
                {
                    !loading && !isLaptop &&
                    <BreadComps
                        title0={productDetail[0]?.category_name}
                        link0={productDetail[0]?.category_url}
                        title1={productDetail[0]?.subcategory_name}
                        link1={productDetail[0]?.subcategory_url}
                        title2={productDetail[0]?.sub_sub_category_name}
                        link2={productDetail[0]?.sub_sub_category_url}
                        activetitle={productDetail[0]?.name}
                    />
                }
                {
                    !loading ?
                        <Row className='mt-3'>
                            <Col lg={4}>
                                {
                                    isMobile &&
                                    <div className="product_Detail_right_side">
                                        <h3 style={{ fontSize: 14 }}>{productDetail[0].name}</h3>
                                    </div>
                                }
                                <div className="product_Detail_left_side">
                                    <ReactImageMagnify
                                        {...{
                                            smallImage: {
                                                alt: 'Product Image',
                                                isFluidWidth: true,
                                                src: productDetail[0].images[current_image]
                                            },
                                            largeImage: {
                                                src: productDetail[0].images[current_image],
                                                width: 1200,
                                                height: 1200
                                            },
                                            enlargedImageContainerDimensions: {
                                                width: '200%',  // Set the width of the side zoomed image
                                                height: '100%'
                                            },
                                            enlargedImageContainerStyle: {
                                                border: 'none'  // Remove the border
                                            }
                                        }}
                                    />


                                    <ImageCarousel images={productDetail[0].images} setcurrent_image={setcurrent_image} current_image={current_image} />

                                    {
                                        productDetail[0].stock == "In stock" ?



                                            <div className="product_detail_btn  mt-3" onClick={handleClick}>
                                                Add to cart
                                                {
                                                    isLoading &&
                                                    <ClipLoader className="ms-3" size={16} color={'#fff'} />
                                                }
                                            </div> :
                                            <>
                                                <div className=" producrdetailnotifybtn mt-3" >
                                                    Notify me
                                                    {
                                                        isLoading &&
                                                        <ClipLoader className="ms-3" size={16} color={'#fff'} />
                                                    }
                                                </div>
                                                <div className="productdetail-notifystatus">Get notified when this item comes back in stock.</div>
                                            </>
                                    }
                                </div>
                            </Col>
                            <Col lg={8}>
                                <div className="product_Detail_right_side">
                                    {
                                        !isMobile &&
                                        <h3>{productDetail[0].name}</h3>
                                    }
                                    {
                                        !isMobile ?
                                            <div className="border_bottom mt-4" />
                                            :
                                            <div className="mt-4" />

                                    }

                                    <div className="product_Detail_price_container mt-1">
                                        <div className="display_price">{currentcountry.currency + " " + productDetail[0].display_price}</div>
                                        {
                                            (productDetail[0].hasOwnProperty('old_price') && !isMobile) &&
                                            <div className="display_percentage">{productDetail[0].percentage + '% OFF'}</div>
                                        }
                                    </div>

                                    {
                                        productDetail[0].hasOwnProperty('old_price') &&
                                        <div className={`old_price ${isMobile && 'mt-2'}`}>
                                            <h5 className="mb-0"></h5><span>{currentcountry.currency + " " + productDetail[0].old_price}</span>
                                            {
                                                isMobile &&
                                                <div className="product_Detail_price_container">
                                                    <div className="display_percentage">{productDetail[0].percentage + '% OFF'}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {
                                        isMobile &&
                                        <div className="border_bottom mt-4" />
                                    }
                                    <div className="d-flex align-items-center mt-3">
                                        <img src={'/assets/vector_icons/delivery_truck.png'} width={20} height={20} />
                                        <h5 className="delivery_exected_by mb-0 ms-2">{productDetail[0].delivery}</h5>
                                    </div>

                                    {
                                        isMobile &&
                                        <div className="border_bottom mt-3 mb-4" />
                                    }

                                    {
                                        productDetail[0].bank_offers.length > 0 &&
                                        <>
                                            <h5 className="bank_offers mt-3">Bank Offers</h5>

                                            <div className="bank_offers_list mt-3">
                                                {
                                                    productDetail[0].bank_offers.slice(0, view_more).map((bank_offer) => {
                                                        return (
                                                            <div className="bank_offers_item">
                                                                <img src={'/assets/vector_icons/offer.png'} />
                                                                <span className="mx-2">{bank_offer.value}</span>
                                                                <img src={bank_offer.image} width={74} height={19} />
                                                                {
                                                                    isMobile ?
                                                                        <div className="d-flex mx-3">
                                                                            <div className="mx-2" style={{ fontWeight: 600 }}>{bank_offer.tag}</div>
                                                                            <div style={{ fontWeight: 600, color: '#3B82F6', textDecoration: "underline", cursor: "pointer" }} onClick={() => bankofferclick(bank_offer?.modal_data)} >Learn more</div>
                                                                        </div>
                                                                        :
                                                                        <>
                                                                            <span className="mx-2" style={{ fontWeight: 600 }}>{bank_offer.tag}</span>
                                                                            <span className="mx-1" style={{ fontWeight: 600, color: '#3B82F6', textDecoration: "underline", cursor: "pointer" }} onClick={() => bankofferclick(bank_offer?.modal_data)}>Learn more</span>
                                                                        </>


                                                                }

                                                            </div>
                                                        )
                                                    })
                                                }

                                            </div>

                                            <h5 className="view_more mt-3" onClick={handleViewMore}>
                                                {
                                                    view_more == productDetail[0].bank_offers.length ? 'view less' : 'view more'
                                                }
                                            </h5>

                                        </>

                                    }

                                    {
                                        // bankofferdata?.length > 0 &&
                                        <Bankoffermodal plans={bankofferdata?.plans} />
                                    }
                                    {
                                        currentcountry?.isTabbyRequired &&
                                        <div className="bg_shop_now_pay_later px-3 py-2 mt-3">
                                            <img src={shop_now_pay_later} />
                                            <p className="mt-2">
                                                <img src={shop} className="pe-1" />  Easy Installment Plans with <span className="span_1">0% Interest.</span> <span className="span_2">Pay {currentcountry.currency} {(productDetail[0].display_price * 25) /
                                                    100}</span> Now, Rest pay later. <img src={tabby} className="pe-1 offerImage_tabby" />
                                                <span className="mx-1" style={{ fontWeight: 600, color: '#3B82F6', textDecoration: "underline", cursor: "pointer" }} onClick={() => dispatch(setsnplmodal(true))}>Learn more</span>

                                            </p>
                                        </div>
                                    }

                                    {
                                        <Snplmodal productcost={(productDetail[0].display_price / currentcountry?.emi_months)} />
                                    }


                                    <div className="mt-4"></div>


                                    {/* <div className="snplmain">
                                        <img src={snpl}></img>
                                        <div className="bank_offers_item">
                                            <img src={'/assets/vector_icons/shop.png'} />
                                            <div className="snplcontent"> Easy Installment Plans with 0% Interest. Pay AED 67.6 Now, Rest pay later.</div>
                                       
                                        </div>
                                    </div> */}
                                    {
                                        productDetail[0].alternateAttributes.map((attribute) => {
                                            var current_val = attribute.list.filter(({ sku }) => sku == slug);
                                            return (
                                                <div className="mb-3">
                                                    <div className="variant_name"><h6 className="mb-0">{attribute.title} :</h6> <span>{current_val.length > 0 && current_val[0].name}</span></div>
                                                    <div className="attribute_list mt-2">
                                                        {
                                                            attribute.list.map((attribute_item) => {
                                                                return (
                                                                    <>
                                                                        {
                                                                            attribute_item.code == '' ?
                                                                                <NavLink to={`/details/${attribute_item.url}/${attribute_item.sku}`} className="text-decoration-none attribute_item">
                                                                                    <h6 className={`${slug == attribute_item.sku ? 'variant_type_2_active variant_type_2_active_Color' : 'variant_type_2'}`}>{attribute_item.name}</h6>
                                                                                </NavLink>
                                                                                :
                                                                                <NavLink to={`/details/${attribute_item.url}/${attribute_item.sku}`} className="text-decoration-none attribute_item">
                                                                                    <div className="attribute_border">
                                                                                        <div style={{ borderColor: slug == attribute_item.sku && '#3B82F6' }}>
                                                                                            <div style={{ background: attribute_item.code, width: 34, height: 34, borderRadius: 50 }} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <h6 className={`mt-1 ${slug == attribute_item.sku && 'variant_type_2_active_Color'}`}>{attribute_item.name}</h6>
                                                                                </NavLink>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    <div >
                                        <div className="productoverview">Overview</div>
                                        <div className="productdetail-specificationtitle">Specifications</div>
                                        <div className="specification-main">
                                            {
                                                productDetail[0].small_desc_data.map((ele, index) => {
                                                    return (
                                                        <Row className={` specificationdetails ${index % 2 === 0 ? "evenbacground" : "nooddbackground"}`}>
                                                            <Col lg={6} md={6} sm={6} xs={6} className="specificationtitle">{ele.title}</Col>
                                                            <Col lg={6} md={6} sm={6} xs={6} className="specificationvalue">{ele.value}</Col>
                                                        </Row>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="productdetail-specificationtitle">About this product</div>
                                        <div
                                            className="custom-html-table ms-2"
                                            dangerouslySetInnerHTML={{
                                                __html: decodeHtml(productDetail[0].details),
                                            }}
                                        />
                                    </div>

                                </div>
                            </Col>

                        </Row>
                        :
                        <Row className='mt-3'>
                            <Col lg={4}>
                                <div className="product_Detail_left_side">
                                    <div className="placeholder_color" style={{ width: '100%', height: 450, borderRadius: 8 }} />
                                    <div className="d-flex mt-3">
                                        {
                                            [1, 2, 3, 4, 5].map((_i) => {
                                                return (
                                                    <div className="placeholder_color me-3" style={{ width: '15%', height: 100, borderRadius: 8 }} />
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8}>
                                <div className="product_Detail_right_side">
                                    <div className="placeholder_color" style={{ width: '80%', height: 10, borderRadius: 5 }} />
                                    <div className="placeholder_color mt-3" style={{ width: '20%', height: 10, borderRadius: 5 }} />
                                    <div className="d-block mt-5">
                                        {
                                            [1, 2, 3, 4, 5, 6].map((_i) => {
                                                return (
                                                    <div className="placeholder_color mt-3" style={{ width: '50%', height: 10, borderRadius: 8 }} />
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="d-flex mt-5">
                                        <div className="placeholder_color me-3" style={{ width: '15%', height: 10, borderRadius: 5 }} />
                                        <div className="placeholder_color" style={{ width: '8%', height: 10, borderRadius: 5 }} />
                                    </div>
                                    <div className="d-flex mt-3">
                                        {
                                            [1, 2, 3, 4, 5].map((_i) => {
                                                return (
                                                    <div className="placeholder_color me-3" style={{ width: 40, height: 40, borderRadius: 50 }} />
                                                )
                                            })
                                        }
                                    </div>

                                    <div className="d-flex mt-5">
                                        <div className="placeholder_color me-3" style={{ width: '15%', height: 10, borderRadius: 5 }} />
                                        <div className="placeholder_color" style={{ width: '8%', height: 10, borderRadius: 5 }} />
                                    </div>


                                    <div className="d-flex mt-3">
                                        {
                                            [1, 2, 3, 4, 5].map((_i) => {
                                                return (
                                                    <div className="placeholder_color me-3" style={{ width: 100, height: 40, borderRadius: 10 }} />
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                }
                {
                    !loading1 ?
                        <div className="component_1 product_Detail_carousel_prod mt-5">
                            {
                                productDetail_products.hasOwnProperty("related_products") &&
                                <ComponentHeader title={'Related Products'} first_title={'Related'} second_title={'PRODUCTS'} first_string_color={'#000'} second_string_color={null} view_all={'rgba(82, 50, 194, 1)'} />
                            }
                            {
                                isMobile &&
                                <div className="mt-3"></div>
                            }
                            <CarouselProducts products={productDetail_products.related_products} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                        </div>
                        :
                        <div className="mt-3 row">
                            {
                                [1, 2, 3, 4, 5].map((product) => {
                                    return (
                                        <Col xxl={2} xl={2} lg={3} md={3} sm={6} xs={6} className="mb-4">
                                            <ProductCardPlaceHolder />
                                        </Col>
                                    )
                                })
                            }

                        </div>
                }
                {
                    !loading1 ?
                        <div className="component_1 product_Detail_carousel_prod mt-4">
                            {
                                productDetail_products.hasOwnProperty("recently_viewed") &&
                                <ComponentHeader title={'Recently viewed Products'} first_title={'Recently'} second_title={'viewed PRODUCTS'} first_string_color={'#000'} second_string_color={null} view_all={'rgba(82, 50, 194, 1)'} />
                            }
                            {
                                isMobile &&
                                <div className="mt-3"></div>
                            }
                            <CarouselProducts products={productDetail_products.recently_viewed} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                        </div>
                        :
                        <div className="mt-3 row">
                            {
                                [1, 2, 3, 4, 5].map((product) => {
                                    return (
                                        <Col xxl={2} xl={2} lg={3} md={3} sm={6} xs={6} className="mb-4">
                                            <ProductCardPlaceHolder />
                                        </Col>
                                    )
                                })
                            }

                        </div>
                }
            </Container>
        </>
    )
}

export default ProductDetail;